



























































import {
	computed,
	defineComponent,
	onUnmounted,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import { useThrottledUsersSearch } from '@front-app/hooks/ThrottledApi/userSearch';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { EditorOptions, useTiptapEditor } from '@front-app/components/form/tiptap/useTiptapEditor';
import { useTranslate } from '@front-app/hooks/useTranslate';
import EditorMenu from '@front-app/components/form/tiptap/EditorMenu.vue';
import EditorContent from '@front-app/components/form/tiptap/EditorContent.vue';
import EditorContainer from '@front-app/components/form/tiptap/EditorContainer.vue';
import FormSection from './FormSection.vue';
import FormLabel from './FormLabel.vue';
import FormError from './FormError.vue';
import { Spacing } from '../constants';
import { FOCUSABLE_ERROR_INPUT_CLASS } from './form';
import MentionList from './tiptap/MentionList.vue';

export default defineComponent({
	components: {
		EditorMenu,
		EditorContent,
		EditorContainer,
		FormSection,
		FormLabel,
		FormError,
		MentionList,
	},
	props: {
		label: {
			type: String,
			default: '',
		},
		errorText: {
			type: [String, Boolean],
			default: '',
		},
		id: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: true,
		},
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.WIDE,
		},
		enableAlignment: {
			type: Boolean,
			required: false,
			default: true,
		},
		enableMentions: Boolean,
		// If mentions are enabled, then a groupId is required for searching users
		mentionGroupId: {
			type: String,
			required: false,
			default: '',
		},
		hideLabel: Boolean,
		hideErrorField: Boolean,
		withHelp: Boolean,
	},
	setup(props, ctx) {
		const el = ref(null as null | Element);

		// at-mentions
		// eslint-disable-next-line arrow-body-style
		const searchGroupUsers = useThrottledUsersSearch();

		const {
			track: trackMentionFetch,
			status: mentionFetchStatus,
		} = useAsyncStatus();

		const editorConfig = getEditorConfig();

		const {
			editor,
			selectMention,
			mentionItems,
			mentionListRef,
		} = useTiptapEditor(el, editorConfig);

		function getEditorConfig(): EditorOptions {
			if (props.enableMentions) {
				if (!props.mentionGroupId) {
					throw Error('mentionGroupId is required is enabledMentions is true');
				}
				return {
					atMentionConfig: {
						translationService: useTranslate(ctx),
						mentionProvider: ({ query }) => trackMentionFetch(searchGroupUsers.search(props.mentionGroupId, { name: query, limit: 5 })),
					},
				};
			}
			return {};
		}
		// END at-mentions

		watch(() => props.value, (content, prev) => {
			if (content === prev) {
				return;
			}
			editor.chain().setContent(content).run();
		}, { immediate: true });

		const onUpdate = () => {
			ctx.emit('input', editor.getHTML());
		};

		editor.on('update', onUpdate);
		onUnmounted(() => {
			editor.off('update', onUpdate);
		});

		const hasError = computed(() => Boolean(props.errorText));

		return {
			FOCUSABLE_ERROR_INPUT_CLASS,
			hasError,
			el,
			editor,
			// Mentions
			mentionFetchStatus,
			mentionItems,
			mentionListRef,
			selectMention,
		};
	},
});
